import Button from 'devextreme-react/button';
import { showErrorMessage } from '../../../../utils/messages';
import { useState } from 'react';
import { useSaveChangeOrderScriptForm } from '../api/save-orderChangeCallScriptForm';

const ChangeOrderScriptForm: React.FC<{
    retailOrderID: number,
    retailOrderNumber: string,
    onClosePopup: () => void,
    onCheckboxChange: (checked: boolean) => void,
    onSubmit?: () => void
}> = ({ retailOrderID, retailOrderNumber, onClosePopup, onCheckboxChange, onSubmit }) => {
    const [afterFinalPaymentCheckBox, setAfterFinalPaymentCheckBox] = useState(false);
    const [afterStepsCompletedCheckbox, setAfterStepsCompletedCheckbox] = useState(false);
    const [delivering10StarCheckBox, setDelivering10StarCheckBox] = useState(false);
    const [delivering10StarClosingCheckBox, setDelivering10StarClosingCheckBox] = useState(false);
    const [introduceYourselfCheckBox, setIntroduceYourselfCheckBox] = useState(false);
    const [lowesSurveyPerfectCheckBox, setLowesSurveyPerfectCheckBox] = useState(false);
    const [lowesSurveyPerfectClosingCheckBox, setLowesSurveyPerfectClosingCheckBox] = useState(false);
    const [mayISpeakCheckBox, setMayISpeakCheckBox] = useState(false);
    const [thankCustomerForPurchaseCheckBox, setThankCustomerForPurchaseCheckBox] = useState(false);
    const [thankTheCustomerCheckBox, setThankTheCustomerCheckBox] = useState(false);
    const [toApproveCheckBox, setToApproveCheckBox] = useState(false);
    const [toPayTheNewBalanceCheckbox, setToPayTheNewBalanceCheckbox] = useState(false);
    const [youWillRecieveCheckBox, setYouWillRecieveCheckBox] = useState(false);
    const [youWillRecieveNONImeCheckbox, setYouWillRecieveNONImeCheckbox] = useState(false);
    const [yourProjectHoldCheckBox, setYourProjectHoldCheckBox] = useState(false);
    const [confirmSelectionsCheckbox, setConfirmSelectionsCheckbox] = useState(false);
    const [colorFinishCheckbox, setColorFinishCheckbox] = useState(false);
    const [colorFinishText, setColorFinishText] = useState('');
    const [edgeCheckbox, setEdgeCheckbox] = useState(false);
    const [edgeText, setEdgeText] = useState('');
    const [backsplashCheckbox, setBacksplashCheckbox] = useState(false);
    const [customerSuppliedCheckbox, setCustomerSuppliedCheckbox] = useState(false);
    const [slabCheckbox, setSlabCheckbox] = useState(false);
    const [thickness3cmCheckbox, setThickness3cmCheckbox] = useState(false);
    const [thickness2cmCheckbox, setThickness2cmCheckbox] = useState(false);
    const [heightStandard4Checkbox, setHeightStandard4Checkbox] = useState(false);
    const [heightFullCheckbox, setHeightFullCheckbox] = useState(false);
    const [fullHeightText, setFullHeightText] = useState('');
    const [otherCheckbox, setOtherCheckbox] = useState(false);
    const [otherText, setOtherText] = useState('');
    const [sqftChangesCheckbox, setSQFTChangesCheckbox] = useState(false);
    const [chipMinimizerCheckbox, setChipMinimizerCheckbox] = useState(false);
    const [safetyCornersCheckbox, setSafetyCornersCheckbox] = useState(false);
    const [oversizeSlabCheckbox, setOversizeSlabCheckbox] = useState(false);
    const [oversizeSlabText, setOversizeSlabText] = useState('');
    const [extendedOverhangsCheckbox, setExtendedOverhangsCheckbox] = useState(false);
    const [extendedOverhangsText, setExtendedOverhangsText] = useState('');
    const [supportCustomerSuppliedCheckbox, setSupportCustomerSuppliedCheckbox] = useState(false);
    const [supportInstallerProvidedCheckbox, setSupportInstallerProvidedCheckbox] = useState(false);
    const [plumbingDisconnectCheckbox, setPlumbingDisconnectCheckbox] = useState(false);
    const [plumbingDisconnectInstallerCheckbox, setPlumbingDisconnectInstallerCheckbox] = useState(false);
    const [plumbingDisconnectCustomerCheckbox, setPlumbingDisconnectCustomerCheckbox] = useState(false);
    const [plumbing1120679Checkbox, setPlumbing1120679Checkbox] = useState(false);
    const [plumbing1120669Checkbox, setPlumbing1120669Checkbox] = useState(false);
    const [plumbingReconnectCheckbox, setPlumbingReconnectCheckbox] = useState(false);
    const [plumbingReconnectInstallerCheckbox, setPlumbingReconnectInstallerCheckbox] = useState(false);
    const [plumbingReconnectCustomerCheckbox, setPlumbingReconnectCustomerCheckbox] = useState(false);
    const [granite1120680Checkbox, setGranite1120680Checkbox] = useState(false);
    const [granite1120686Checkbox, setGranite1120686Checkbox] = useState(false);
    const [granite1120685Checkbox, setGranite1120685Checkbox] = useState(false);
    const [granite1120684Checkbox, setGranite1120684Checkbox] = useState(false);
    const [quartz1120670Checkbox, setQuartz1120670Checkbox] = useState(false);
    const [quartz1120676Checkbox, setQuartz1120676Checkbox] = useState(false);
    const [quartz1120675Checkbox, setQuartz1120675Checkbox] = useState(false);
    const [quartz1120674Checkbox, setQuartz1120674Checkbox] = useState(false);
    const [graniteGoldProtectionPlanCheckbox, setGraniteGoldProtectionPlanCheckbox] = useState(false);
    const [gold5YearCheckbox, setGold5YearCheckbox] = useState(false);
    const [gold10YearCheckbox, setGold10YearCheckbox] = useState(false);
    const [afterISubmitCheckboxIME, setAfterISubmitCheckboxIME] = useState(false);
    const [sendSigningLinkCheckbox, setSendSigningLinkCheckbox] = useState(false);
    const [afterISubmitCheckboxNonIME, setAfterISubmitCheckboxNonIME] = useState(false);
    const [noteText, setNoteText] = useState('');

    const saveChangeOrderScriptForm = useSaveChangeOrderScriptForm(
        {
            formObject: {
                RetailOrderID: retailOrderID,
                RetailOrderNo: retailOrderNumber,
                AfterFinalPaymentCheckBox: afterFinalPaymentCheckBox,
                AfterStepsCompletedCheckbox: afterStepsCompletedCheckbox,
                Delivering10StarCheckBox: delivering10StarCheckBox,
                Delivering10StarClosingCheckBox: delivering10StarClosingCheckBox,
                IntroduceYourselfCheckBox: introduceYourselfCheckBox,
                LowesSurveyPerfectCheckBox: lowesSurveyPerfectCheckBox,
                LowesSurveyPerfectClosingCheckBox: lowesSurveyPerfectClosingCheckBox,
                MayISpeakCheckBox: mayISpeakCheckBox,
                ThankCustomerForPurchaseCheckBox: thankCustomerForPurchaseCheckBox,
                ThankTheCustomerCheckBox: thankTheCustomerCheckBox,
                ToApproveCheckBox: toApproveCheckBox,
                ToPayTheNewBalanceCheckbox: toPayTheNewBalanceCheckbox,
                YouWillRecieveCheckBox: youWillRecieveCheckBox,
                YouWillRecieveNONImeCheckbox: youWillRecieveNONImeCheckbox,
                YourProjectHoldCheckBox: yourProjectHoldCheckBox,
                ConfirmSelectionsCheckbox: confirmSelectionsCheckbox,
                ColorFinishCheckbox: colorFinishCheckbox,
                ColorFinishText: colorFinishText,
                EdgeCheckbox: edgeCheckbox,
                EdgeText: edgeText,
                BacksplashCheckbox: backsplashCheckbox,
                CustomerSuppliedCheckbox: customerSuppliedCheckbox,
                SlabCheckbox: slabCheckbox,
                Thickness3cmCheckbox: thickness3cmCheckbox,
                Thickness2cmCheckbox: thickness2cmCheckbox,
                HeightStandard4Checkbox: heightStandard4Checkbox,
                HeightFullCheckbox: heightFullCheckbox,
                FullHeightText: fullHeightText,
                OtherText: otherText,
                OtherCheckbox: otherCheckbox,
                SQFTChangesCheckbox: sqftChangesCheckbox,
                SafetyCornersCheckbox: safetyCornersCheckbox,
                ChipMinimizerCheckbox: chipMinimizerCheckbox,
                OversizeSlabCheckbox: oversizeSlabCheckbox,
                OversizeSlabText: oversizeSlabText,
                ExtendedOverhangsCheckbox: extendedOverhangsCheckbox,
                ExtendedOverhangsText: extendedOverhangsText,
                SupportCustomerSuppliedCheckbox: supportCustomerSuppliedCheckbox,
                SupportInstallerProvidedCheckbox: supportInstallerProvidedCheckbox,
                PlumbingDisconnectCheckbox: plumbingDisconnectCheckbox,
                PlumbingDisconnectInstallerCheckbox: plumbingDisconnectInstallerCheckbox,
                PlumbingDisconnectCustomerCheckbox: plumbingDisconnectCustomerCheckbox,
                Plumbing1120679Checkbox: plumbing1120679Checkbox,
                Plumbing1120669Checkbox: plumbing1120669Checkbox,
                PlumbingReconnectCheckbox: plumbingReconnectCheckbox,
                PlumbingReconnectInstallerCheckbox: plumbingReconnectInstallerCheckbox,
                PlumbingReconnectCustomerCheckbox: plumbingReconnectCustomerCheckbox,
                Granite1120680Checkbox: granite1120680Checkbox,
                Granite1120686Checkbox: granite1120686Checkbox,
                Granite1120685Checkbox: granite1120685Checkbox,
                Granite1120684Checkbox: granite1120684Checkbox,
                Quartz1120670Checkbox: quartz1120670Checkbox,
                Quartz1120676Checkbox: quartz1120676Checkbox,
                Quartz1120675Checkbox: quartz1120675Checkbox,
                Quartz1120674Checkbox: quartz1120674Checkbox,
                GraniteGoldProtectionPlanCheckbox: graniteGoldProtectionPlanCheckbox,
                Gold5YearCheckbox: gold5YearCheckbox,
                Gold10YearCheckbox: gold10YearCheckbox,
                AfterISubmitCheckboxIME: afterISubmitCheckboxIME,
                SendSigningLinkCheckbox: sendSigningLinkCheckbox,
                AfterISubmitCheckboxNonIME: afterISubmitCheckboxNonIME,
                NoteText: noteText
            }
        },
        (result) => {
            onClosePopup();
            onCheckboxChange(true);
            if (onSubmit !== undefined) onSubmit!();
        },
        (error) => showErrorMessage(error)
    );

    const handleColorFinishText = (event: React.ChangeEvent<HTMLInputElement>) => {
        setColorFinishText(event.target.value);
    };

    const handleEdgeText = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEdgeText(event.target.value);
    };

    const handleFullHeightText = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFullHeightText(event.target.value);
    };

    const handleOtherText = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOtherText(event.target.value);
    };

    const handleOversizeSlabText = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOversizeSlabText(event.target.value);
    };

    const handleExtendedOverhangsText = (event: React.ChangeEvent<HTMLInputElement>) => {
        setExtendedOverhangsText(event.target.value);
    };

    const handleNoteText = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNoteText(event.target.value);
    };

    const handleReset = () => {
        setAfterFinalPaymentCheckBox(false);
        setAfterStepsCompletedCheckbox(false);
        setDelivering10StarCheckBox(false);
        setDelivering10StarClosingCheckBox(false);
        setIntroduceYourselfCheckBox(false);
        setLowesSurveyPerfectCheckBox(false);
        setLowesSurveyPerfectClosingCheckBox(false);
        setMayISpeakCheckBox(false);
        setThankCustomerForPurchaseCheckBox(false);
        setThankTheCustomerCheckBox(false);
        setToApproveCheckBox(false);
        setToPayTheNewBalanceCheckbox(false);
        setYouWillRecieveCheckBox(false);
        setYouWillRecieveNONImeCheckbox(false);
        setYourProjectHoldCheckBox(false);
        setConfirmSelectionsCheckbox(false);
        setColorFinishText('');
        setEdgeText('');
        setBacksplashCheckbox(false);
        setCustomerSuppliedCheckbox(false);
        setSlabCheckbox(false);
        setThickness3cmCheckbox(false);
        setThickness2cmCheckbox(false);
        setHeightStandard4Checkbox(false);
        setFullHeightText('');
        setHeightFullCheckbox(false);
        setOtherCheckbox(false);
        setOtherText('');
        setSQFTChangesCheckbox(false);
        setChipMinimizerCheckbox(false);
        setSafetyCornersCheckbox(false);
        setOversizeSlabCheckbox(false);
        setOversizeSlabText('');
        setExtendedOverhangsCheckbox(false);
        setExtendedOverhangsText('');
        setSupportCustomerSuppliedCheckbox(false);
        setSupportInstallerProvidedCheckbox(false);
        setPlumbingDisconnectCheckbox(false);
        setPlumbingDisconnectInstallerCheckbox(false);
        setPlumbingDisconnectCustomerCheckbox(false);
        setPlumbing1120679Checkbox(false);
        setPlumbing1120669Checkbox(false);
        setPlumbingReconnectCheckbox(false);
        setPlumbingReconnectInstallerCheckbox(false);
        setPlumbingReconnectCustomerCheckbox(false);
        setGranite1120680Checkbox(false);
        setGranite1120686Checkbox(false);
        setGranite1120685Checkbox(false);
        setGranite1120684Checkbox(false);
        setQuartz1120670Checkbox(false);
        setQuartz1120676Checkbox(false);
        setQuartz1120675Checkbox(false);
        setQuartz1120674Checkbox(false);
        setGold5YearCheckbox(false);
        setGold10YearCheckbox(false);
        setAfterISubmitCheckboxIME(false);
        setSendSigningLinkCheckbox(false);
        setGraniteGoldProtectionPlanCheckbox(false);
        setColorFinishCheckbox(false);
        setEdgeCheckbox(false);
        setOtherText('');
        setAfterISubmitCheckboxNonIME(false);
        setNoteText('');
    };

    return (
        <div>
            <div className='main-header'>
                <h1>Project Manager - Change Order Script 2024</h1>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Greeting</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={mayISpeakCheckBox} onChange={(e) => setMayISpeakCheckBox(e.target.checked)} />
                        “May I speak to (customer name)”
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={introduceYourselfCheckBox} onChange={(e) => setIntroduceYourselfCheckBox(e.target.checked)} />
                        Introduce yourself, your company - in partnership with Lowe’s, and that you’re calling about the
                        changes to their order after their template / measure for their <b>Lowe’s Countertop Project</b>.
                    </label>
                </div>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Discuss Change Order Details</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={thankTheCustomerCheckBox} onChange={(e) => setThankTheCustomerCheckBox(e.target.checked)} />
                        Thank the customer for allowing us into their home to complete the template
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={lowesSurveyPerfectCheckBox} onChange={(e) => setLowesSurveyPerfectCheckBox(e.target.checked)} />
                        <b>Lowe’s survey perfect score expectation</b> – “serves as our report card and only scored on a perfect 10.”
                    </label>
                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={delivering10StarCheckBox} onChange={(e) => setDelivering10StarCheckBox(e.target.checked)} />
                            "Delivering a 10-star countertop experience is our aim, and we're eager to earn your
                            recommendation through our report card. Your feedback is invaluable in helping us
                            achieve a perfect 10 star review."
                        </label>
                    </div>

                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={confirmSelectionsCheckbox} onChange={(e) => setConfirmSelectionsCheckbox(e.target.checked)} />
                        <b>Confirm customer's original selections</b>
                    </label>
                    <div className='section-row-section-hint'>
                        <span className="floatLeft">
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={colorFinishCheckbox} onChange={(e) => setColorFinishCheckbox(e.target.checked)} />
                                    Color & Finish
                                </span>
                                <span style={{ marginLeft: "10px" }}>
                                    <input
                                        type="text"
                                        style={{ width: "240px" }}
                                        value={colorFinishText}
                                        onChange={handleColorFinishText}
                                        placeholder="" />
                                </span>
                            </label>
                        </span>
                        <span >
                            <label>
                                <span className="floatLeft" style={{ marginLeft: "90px" }}>
                                    <input type="CheckBox" checked={edgeCheckbox} onChange={(e) => setEdgeCheckbox(e.target.checked)} />
                                    Edge
                                </span>
                                <span style={{ marginLeft: "10px" }}>
                                    <input
                                        type="text"
                                        style={{ width: "240px" }}
                                        value={edgeText}
                                        onChange={handleEdgeText}
                                        placeholder="" />
                                </span>
                            </label>
                        </span>
                    </div>
                    <div className='section-row-section-hint'>
                        <span className="floatLeft">
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={backsplashCheckbox} onChange={(e) => setBacksplashCheckbox(e.target.checked)} />
                                    Backsplash
                                </span>

                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "10px" }}>
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={customerSuppliedCheckbox} onChange={(e) => setCustomerSuppliedCheckbox(e.target.checked)} />
                                    Customer Supplied
                                </span>

                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "10px" }}>
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={slabCheckbox} onChange={(e) => setSlabCheckbox(e.target.checked)} />
                                    Slab
                                </span>
                            </label>
                        </span>
                    </div>
                    <div className='section-row-section-hint' style={{ marginLeft: "20px" }}>
                        <span className="floatLeft">
                            <label>
                                <span className="floatLeft">
                                    If slab – Thickness:
                                </span>

                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "10px" }}>
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={thickness3cmCheckbox} onChange={(e) => setThickness3cmCheckbox(e.target.checked)} />
                                    3CM
                                </span>

                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "10px" }}>
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={thickness2cmCheckbox} onChange={(e) => setThickness2cmCheckbox(e.target.checked)} />
                                    2CM
                                </span>
                            </label>
                        </span>
                    </div>
                    <div className='section-row-section-hint' style={{ marginLeft: "20px" }}>
                        <span className="floatLeft">
                            <label>
                                <span className="floatLeft">
                                    If slab - Height:
                                </span>
                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "10px" }}>
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={heightStandard4Checkbox} onChange={(e) => setHeightStandard4Checkbox(e.target.checked)} />
                                    Standard-4”
                                </span>
                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "10px" }}>
                            <label>
                                <span className="floatLeft" style={{ marginLeft: "40px" }}>
                                    <input type="CheckBox" checked={heightFullCheckbox} onChange={(e) => setHeightFullCheckbox(e.target.checked)} />
                                    Full Height:
                                </span>
                                <span style={{ marginLeft: "10px" }}>
                                    <input
                                        type="text"
                                        style={{ width: "140px" }}
                                        value={fullHeightText}
                                        onChange={handleFullHeightText}
                                        placeholder="" />
                                </span>
                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "10px" }}>
                            <label>
                                <span className="floatLeft" style={{ marginLeft: "40px" }}>
                                    <input type="CheckBox" checked={otherCheckbox} onChange={(e) => setOtherCheckbox(e.target.checked)} />
                                    Other:
                                </span>
                                <span style={{ marginLeft: "10px" }}>
                                    <input
                                        type="text"
                                        style={{ width: "140px" }}
                                        value={otherText}
                                        onChange={handleOtherText}
                                        placeholder="" />
                                </span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className='section-row' >
                    <span className="floatLeft">
                        <span className="floatLeft">
                            Discuss the changes and enhancement options that will be quoted on the change order, some items can be removed
                            if customer opts to (explain which cannot):
                        </span>
                        <span className="floatLeft" style={{ marginTop: "10px" }}>
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={sqftChangesCheckbox} onChange={(e) => setSQFTChangesCheckbox(e.target.checked)} />
                                    SQFT changes
                                </span>
                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "10px", marginTop: "10px" }}>
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={chipMinimizerCheckbox} onChange={(e) => setChipMinimizerCheckbox(e.target.checked)} />
                                    Chip Minimizer
                                </span>
                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "10px", marginTop: "10px" }}>
                            <label>
                                <span className="floatLeft">
                                    <input type="CheckBox" checked={safetyCornersCheckbox} onChange={(e) => setSafetyCornersCheckbox(e.target.checked)} />
                                    Safety Corners
                                </span>
                            </label>
                        </span>
                    </span>
                </div>
                <div className='section-row'>
                    <span className="floatLeft">
                        <label>
                            <span className="floatLeft">
                                <label>
                                    <span className="floatLeft">
                                        <input type="CheckBox" checked={oversizeSlabCheckbox} onChange={(e) => setOversizeSlabCheckbox(e.target.checked)} />
                                        Oversize Slab (if applicable, explain reason)
                                    </span>
                                </label>
                            </span>
                            <span style={{ marginLeft: "10px" }}>
                                <input
                                    type="text"
                                    style={{ width: "240px" }}
                                    value={oversizeSlabText}
                                    onChange={handleOversizeSlabText}
                                    placeholder="" />
                            </span>
                        </label>
                    </span>
                </div>
                <div className='section-row'>
                    <span className="floatLeft">
                        <label>
                            <span className="floatLeft">
                                <label>
                                    <span className="floatLeft">
                                        <input type="CheckBox" checked={extendedOverhangsCheckbox} onChange={(e) => setExtendedOverhangsCheckbox(e.target.checked)} />
                                        Extended Overhangs (if applicable)
                                    </span>
                                </label>
                            </span>
                            <span style={{ marginLeft: "10px" }}>
                                <input
                                    type="text"
                                    style={{ width: "240px" }}
                                    value={extendedOverhangsText}
                                    onChange={handleExtendedOverhangsText}
                                    placeholder="" />
                            </span>
                        </label>
                    </span>
                    <div className='section-row-section-hint'>
                        <span className="floatLeft">
                            <span className="floatLeft" style={{ marginLeft: "20px" }}>
                                <span className="floatLeft">
                                    Support:
                                </span>
                                <span className="floatLeft" style={{ marginLeft: "10px" }}>
                                    <label>
                                        <input type="CheckBox" checked={supportCustomerSuppliedCheckbox} onChange={(e) => setSupportCustomerSuppliedCheckbox(e.target.checked)} />
                                        Customer Supplied
                                    </label>
                                </span>
                                <span className="floatLeft" style={{ marginLeft: "10px" }}>
                                    <label>
                                        <input type="CheckBox" checked={supportInstallerProvidedCheckbox} onChange={(e) => setSupportInstallerProvidedCheckbox(e.target.checked)} />
                                        Installer Provided
                                    </label>
                                </span>
                            </span>
                        </span>
                    </div>
                </div>
                <div className='section-row' >
                    <span className="floatLeft" style={{ marginTop: "10px" }}>
                        <label>
                            <span className="floatLeft">
                                <input type="CheckBox" checked={plumbingDisconnectCheckbox} onChange={(e) => setPlumbingDisconnectCheckbox(e.target.checked)} />
                                <b>Plumbing Disconnect:</b>
                            </span>
                        </label>
                    </span>
                    <span className="floatLeft" style={{ marginLeft: "10px", marginTop: "10px" }}>
                        <label>
                            <span className="floatLeft">
                                <input type="CheckBox" checked={plumbingDisconnectInstallerCheckbox} onChange={(e) => setPlumbingDisconnectInstallerCheckbox(e.target.checked)} />
                                Installer*
                            </span>
                        </label>
                    </span>
                    <span className="floatLeft" style={{ marginLeft: "10px", marginTop: "10px" }}>
                        <label>
                            <span className="floatLeft">
                                <input type="CheckBox" checked={plumbingDisconnectCustomerCheckbox} onChange={(e) => setPlumbingDisconnectCustomerCheckbox(e.target.checked)} />
                                Customer
                            </span>
                        </label>
                    </span>
                    <div className="section-row-section-hint">
                        <label>
                            <div className="floatLeft " >
                                <i>*Select the applicable option below if Installer is selected and SKUs are offered through Lowe’s:</i>
                            </div>
                        </label>
                    </div>
                    <div className=" section-row-section-hint">
                        <span className="floatLeft" style={{ marginTop: "10px" }}>
                            <label>
                                <input type="CheckBox" checked={plumbing1120679Checkbox} onChange={(e) => setPlumbing1120679Checkbox(e.target.checked)} />
                                1120679: Granite Plumbing: Plumbing Disconnect
                            </label>
                        </span>
                        <span className="floatLeft" style={{ marginLeft: "20px", marginTop: "10px" }}>
                            <label>
                                <input type="CheckBox" checked={plumbing1120669Checkbox} onChange={(e) => setPlumbing1120669Checkbox(e.target.checked)} />
                                1120669: Quartz Plumbing: Plumbing Disconnect
                            </label>
                        </span>
                    </div>
                </div>
                <div className='section-row' >
                    <span className="floatLeft" >
                        <label>
                            <input type="CheckBox" checked={plumbingReconnectCheckbox} onChange={(e) => setPlumbingReconnectCheckbox(e.target.checked)} />
                            <b>Plumbing Reconnect:</b>
                        </label>
                    </span>
                    <span className="floatLeft" style={{ marginLeft: "10px" }}>
                        <label>
                            <input type="CheckBox" checked={plumbingReconnectInstallerCheckbox} onChange={(e) => setPlumbingReconnectInstallerCheckbox(e.target.checked)} />
                            Installer*:
                        </label>
                    </span>
                    <span className="floatLeft" style={{ marginLeft: "10px" }}>
                        <label>
                            <input type="CheckBox" checked={plumbingReconnectCustomerCheckbox} onChange={(e) => setPlumbingReconnectCustomerCheckbox(e.target.checked)} />
                            Customer:
                        </label>
                    </span>
                    <div className="section-row-section-hint">
                        <label>
                            <div className="floatLeft " >
                                <i>*Select all applicable options below if Installer is selected and SKUs are offered through Lowe’s:</i>
                            </div>
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label>
                            <div >
                                <b>GRANITE:</b>
                            </div>
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={granite1120680Checkbox} onChange={(e) => setGranite1120680Checkbox(e.target.checked)} />
                            1120680: Granite Plumbing: Plumbing Connection of New Main Faucet & Drains to New Sink
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label >
                            <input type="CheckBox" checked={granite1120686Checkbox} onChange={(e) => setGranite1120686Checkbox(e.target.checked)} />
                            1120686: Granite Plumbing: Connect New Faucet Shutoff Valves (includes hot & cold shutoff valves)
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label >
                            <input type="CheckBox" checked={granite1120685Checkbox} onChange={(e) => setGranite1120685Checkbox(e.target.checked)} />
                            1120685: Granite Plumbing: Install New/Existing Dishwasher & Plumbing Connection
                        </label>
                    </div>

                    <div className="section-row-section-hint">
                        <label >
                            <input type="CheckBox" checked={granite1120684Checkbox} onChange={(e) => setGranite1120684Checkbox(e.target.checked)} />
                            1120684: Granite Plumbing: Install New/Existing Garbage Disposal & Plumbing Connection
                        </label>
                    </div>

                    <div className="section-row-section-hint">
                        <label>
                            <div  >
                                <b>QUARTZ:</b>
                            </div>
                        </label>
                    </div>

                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={quartz1120670Checkbox} onChange={(e) => setQuartz1120670Checkbox(e.target.checked)} />
                            1120670: Quartz Plumbing: Plumbing Connection of New Main Faucet & Drains to New Sink
                        </label>
                    </div>

                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={quartz1120676Checkbox} onChange={(e) => setQuartz1120676Checkbox(e.target.checked)} />
                            1120676: Quartz Plumbing: Connect New Faucet Shutoff Valves (includes hot & cold shutoff valves)
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={quartz1120675Checkbox} onChange={(e) => setQuartz1120675Checkbox(e.target.checked)} />
                            1120675: Quartz Plumbing: Install New/Existing Dishwasher & Plumbing Connection
                        </label>
                    </div>
                    <div className="section-row-section-hint">
                        <label>
                            <input type="CheckBox" checked={quartz1120674Checkbox} onChange={(e) => setQuartz1120674Checkbox(e.target.checked)} />
                            1120674: Quartz Plumbing: Install New/Existing Garbage Disposal & Plumbing Connection
                        </label>
                    </div>
                </div>
                <div className='section-row' >
                    <span className="floatLeft" >
                        <label>
                            <input type="CheckBox" checked={graniteGoldProtectionPlanCheckbox} onChange={(e) => setGraniteGoldProtectionPlanCheckbox(e.target.checked)} />
                            <b>Granite Gold Protection Plan:</b>
                        </label>
                    </span>
                    <span className="floatLeft" style={{ marginLeft: "10px" }}>
                        <label>
                            <input type="CheckBox" checked={gold5YearCheckbox} onChange={(e) => setGold5YearCheckbox(e.target.checked)} />
                            5 year-$299 retail
                        </label>
                    </span>
                    <span className="floatLeft" style={{ marginLeft: "10px" }}>
                        <label>
                            <input type="CheckBox" checked={gold10YearCheckbox} onChange={(e) => setGold10YearCheckbox(e.target.checked)} />
                            10 year-$399 retail
                        </label>
                    </span>
                </div>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>IME Orders - Explain next steps</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={afterISubmitCheckboxIME} onChange={(e) => setAfterISubmitCheckboxIME(e.target.checked)} />
                        “After I submit this change order, your project is on hold and cannot move forward until the
                        change order is approved and final payment is submitted.”
                    </label>
                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={toApproveCheckBox} onChange={(e) => setToApproveCheckBox(e.target.checked)} />
                            <b>To approve and make final payment</b> - ask the customer to login to their My Projects account
                            or look for an email that says “Let’s Get Your Change Order Signed” to login to their account.
                            This will send shortly after the change order is submitted.
                        </label>
                    </div>
                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={sendSigningLinkCheckbox} onChange={(e) => setSendSigningLinkCheckbox(e.target.checked)} />
                            If the customer informs you that the email cannot be found, in Sage Sync click on Send
                            Signing Link after selecting View Change Request on their RO, this will resend the change
                            order email.
                        </label>
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={afterStepsCompletedCheckbox} onChange={(e) => setAfterStepsCompletedCheckbox(e.target.checked)} />
                        “After these steps are completed, we will order your material (if applicable) and begin
                        fabrication.”
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={youWillRecieveCheckBox} onChange={(e) => setYouWillRecieveCheckBox(e.target.checked)} />
                        “You will receive another call from us to schedule your installation appointment. Please contact
                        us directly with any scheduling questions.”
                    </label>
                </div>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>NON-IME Orders – Explain next steps</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={afterISubmitCheckboxNonIME} onChange={(e) => setAfterISubmitCheckboxNonIME(e.target.checked)} />
                        After I submit this change order, your project is on hold and cannot move forward until you
                        have paid the new balance on the change order
                    </label>
                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={toPayTheNewBalanceCheckbox} onChange={(e) => setToPayTheNewBalanceCheckbox(e.target.checked)} />
                            <b>To pay the new balance </b> – ask the customer to “please visit the Lowe’s store (provide store
                                name) where you made your purchase and speak with a kitchen designer.”
                        </label>
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={afterFinalPaymentCheckBox} onChange={(e) => setAfterFinalPaymentCheckBox(e.target.checked)} />
                        “After final payment has been received, we will order your material (if applicable) and begin
                        fabrication.”
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={youWillRecieveNONImeCheckbox} onChange={(e) => setYouWillRecieveNONImeCheckbox(e.target.checked)} />
                        “You will receive another call from us to schedule your installation appointment. Please contact
                        us directly with any scheduling questions.”
                    </label>
                </div>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Closing</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={lowesSurveyPerfectClosingCheckBox} onChange={(e) => setLowesSurveyPerfectClosingCheckBox(e.target.checked)} />
                        <b>Lowe’s survey perfect score expectation</b> – “serves as our report card and only scored on a
                        perfect 10.”
                    </label>
                    <div className='section-row-section-hint'>
                        <label>
                            <input type="CheckBox" checked={delivering10StarClosingCheckBox} onChange={(e) => setDelivering10StarClosingCheckBox(e.target.checked)} />
                            “Delivering a 10-star countertop experience is our aim, and we’re eager to earn your
                            recommendation through our report card. Your feedback is invaluable in helping us achieve
                            a perfect 10-star review. If there’s any reason why we haven’t met your expectations, please
                            let me know.”
                        </label>
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox" checked={thankCustomerForPurchaseCheckBox} onChange={(e) => setThankCustomerForPurchaseCheckBox(e.target.checked)} />
                        Thank customer for purchase, provide contact information
                    </label>
                </div>
                <div className='section-row'>
                    Notes:
                    <textarea
                        className='input-fullsize-large-height'
                        value={noteText}
                        onChange={handleNoteText}
                        placeholder="Note"
                        rows={5}
                        cols={40}
                    />
                </div>
            </div>

            <div className='button-container'>
                <Button
                    text="Reset"
                    className='reset-button'
                    type="danger"
                    onClick={(e) => {
                        handleReset()
                    }} >
                </Button>

                <Button
                    text="Save Changes"
                    className="save-button"
                    onClick={(e) => {
                        saveChangeOrderScriptForm.mutate();
                    }} >
                </Button>
            </div>
        </div >
    );
};

export default ChangeOrderScriptForm;
